import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

/**
 * Iter 80 — Campo "¿Cómo nos has conocido?" (Customer Referral Source).
 * Iter 160 — La gestión de opciones vive en Configuración → Empresa.
 *
 * Props:
 *  - value         valor actual (label canónico) o ""
 *  - onChange(v)   callback
 *  - editing       si false, sólo lectura (no select, sólo texto)
 *  - required      si true, marca el select como required (sólo en clientes nuevos)
 */
export default function ReferralSourceField({ value, onChange, editing, required }) {
  const [sources, setSources] = useState([]);

  useEffect(() => {
    api.get("/settings/customer-referral-sources")
      .then((r) => setSources(r.data || []))
      .catch((err) => toast.error(formatApiError(err)));
  }, []);

  const active = sources.filter((s) => s.active);
  // si value no está en active pero sí existe (legado o desactivado), lo añadimos para no perderlo
  const inOptions = sources.find((s) => (s.label || "").toLowerCase() === (value || "").toLowerCase());
  const visible = inOptions && !active.includes(inOptions) ? [...active, inOptions] : active;

  if (!editing) {
    return (
      <div>
        <label className="font-mono text-[10px] uppercase tracking-widest text-[#525252]">
          ¿Cómo nos has conocido?
        </label>
        <div className="mt-1 px-3 py-2 text-sm border border-transparent bg-[#F7F7F4] min-h-[36px]" data-testid="customer-field-referral-readonly">
          {value || <span className="text-[#525252]">—</span>}
        </div>
      </div>
    );
  }

  return (
    <div>
      <label className="font-mono text-[10px] uppercase tracking-widest text-[#525252]">
        ¿Cómo nos has conocido?{required ? " *" : ""}
      </label>
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        data-testid="customer-field-referral"
        className="mt-1 w-full ds-card focus:border-[#6E8B3D] focus:ring-1 focus:ring-[#6E8B3D] outline-none px-3 py-2 text-sm rounded-none bg-white"
      >
        <option value="">Seleccionar una opción</option>
        {visible.map((s) => (
          <option key={s.id} value={s.label}>{s.label}{!s.active ? " (inactivo)" : ""}</option>
        ))}
      </select>
    </div>
  );
}
